<div class="right-margin">
    <button class="close-icon" (click)="cancel()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body sellerTermDialogForm form">
    <h2>{{(sellerContract.id>0)?'Update':'Add'}} Sales Agreement</h2>
    <div class="row m-0">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
            <div class="d-flex">
                <div class="mr-3 auto">
                    <input type="text" [class]="getClassesForInput('name', true, sellerContract.name)" name="name" [(ngModel)]="sellerContract.name" (input)="resetError('name')" (focus)="focusField('name')"
                           (focusout)="focusOutField('name')" placeholder="Name" />
                    @if (getVisibilityForLabel(sellerContract.name)) {
                    <div class="placeholder">Name</div>
                    }
                </div>
                <div class="auto">
                    <select [(ngModel)]="sellerContract.termRescission" (input)="resetError('termRescission')" [class]="getClassesForInput('termRescission', true, (sellerContract.termRescission==null)?null:''+sellerContract.termRescission)" (focus)="focusField('termRescission')" (focusout)="focusOutField('termRescission')">
                        @for (termRecision of termRescissions; track termRecision; let i = $index) {
                        <option [ngValue]="i">{{termRecision}}</option>
                        }
                    </select>
                    <div class="placeholder">Term of Rescission (days)</div>
                </div>
            </div>
            <hr/>
            <mat-tab-group mat-align-tabs="start" #tabs>
                <mat-tab label="Sales Agreement">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-3 pr-0">
                        <label class="sellerAccountLabel  w-100">Please type or paste a copy of your terms and conditions</label>
                        <div class="d-flex mb-3">
                            <label class="customRadioBtn mr-3 sellerAccInput" for="uploadDoc">
                                <input type="radio" class="customRadioInput" id="uploadDoc" name="termsDocument" (change)="selectUseUpload(true)" [checked]="useUpload" value="uploadDoc">Upload a document
                            </label>
                            <label class="customRadioBtn sellerAccInput" for="inputTextBox">
                                <input type="radio" class="customRadioInput" id="inputTextBox" name="termsDocument" (change)="selectUseUpload(false)" [checked]="!useUpload" value="inputBox">Input in the textbox
                            </label>
                        </div>
                        @if (useUpload) {
                        <div>
                            @if ((fileToUpload==null && sellerContract.termsDocument==null)) {
                            <label class="formLabel" [class]="(errorY().isWrong('fileToUpload'))?'error':''">
                                CHOOSE FILES
                                <span>no file selected</span>
                                <input type="file" name="fileToUpload" class="required" value="" placeholder="Terms &amp; Conditions" (change)="handleFileInput($event)" />
                            </label>
                            }
                            @if ((fileToUpload!=null || sellerContract.termsDocument!=null)) {
                            <div class="files-list">
                                @if (fileToUpload!=null) {
                                <span>1 file selected</span>
                                }
                                <ul>
                                    @if (fileToUpload!=null) {
                                    <li><a (click)="deleteFile(false)"></a><div class="link" (click)="downloadFile(false)">{{fileToUpload.name}}</div></li>
                                    }
                                    @if (sellerContract.termsDocument!=null) {
                                    <li><a (click)="deleteFile(true)"></a><div class="link" (click)="downloadFile(true)">{{sellerContract.termsDocument.value}}</div></li>
                                    }
                                </ul>
                            </div>
                            }
                        </div>
                        }
                        @if (!useUpload) {
                        <div>
                            <div [class]="(errorY().isWrong('terms'))?'error':''" class="textarea-basis">
                                <quill-editor [(ngModel)]="sellerContract.terms"></quill-editor>
                            </div>
                        </div>
                        }
                    </div>
                </mat-tab>
                <mat-tab label="Disclosure Statement">
                    <div>
                        <div class="textarea-basis">
                            <quill-editor [(ngModel)]="sellerContract.disclosureStatement"></quill-editor>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>

            @if (this.errorY().showError()) {
            <div class="error-block">{{this.errorY().error}}</div>
            }
            <div class="block-buttons">
                <button type="button" (click)="sendForm()">{{(sellerContract.id>0)?'Update':'Add'}}</button>
            </div>
        </div>
    </div>
